module.exports = __webpack_public_path__ + "static/media/bg-img.e195a258.svg";